export class AuthModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
    includePermissions: boolean;
    includeRoles: boolean;  
    partnerId: number; 
}

export interface AuthenticationResponseModelData {
  result: AuthenticationResponseModel;
}

export class AuthenticationResponseModel {
  accessToken: string;
  encryptedAccessToken: string;
  expireInSeconds: number;
  shouldResetPassword: boolean;
  passwordResetCode: string;
  userId: number;
  tenantId: number;
  requiresTwoFactorVerification: boolean;
  twoFactorAuthProviders: string[];
  permissions: string[];
  roles: string[];
  twoFactorRememberClientToken: string;
  returnUrl: string;
  IsNewUser: boolean = false;
}

export class LinkedUserResponseModel {
  tenantId: number;
  tenantName: string;
  tenancyName: number;
  userId: number;
}

export class LinkedUserAuthModel{
  userId: number;
  partnerId: number;
}

export class StsTokenOutput {
  constructor() {
      this.result = new StsTokenResult();
  }

  public result : StsTokenResult;
}

export class OktaAuthModel {
  issuer?: string;
  audience?: string;
  name: string;
  domains: string[];
}

export class StsTokenResult {
  constructor() {
      this.access_token = '';
      this.expires_in = 0;
  }

  public access_token: string;
  public expires_in: number;
}
